import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';

import Framework from '../components/framework';
import Breadcrumb from '../components/framework/breadcrumb';
import PageHeader from '../components/framework/pages/page-header';
import TestFilters from '../components/test/filters';
import ProductList from '../components/test/product-list';
import ProductToggleListType from '../components/test/product-toggle-list-type';
import Trans from '../components/translation/trans';
import useQueryParameters from '../hooks/use_query_parameters';
import useTranslation from '../hooks/use_translation';
import { getVariantByLanguage } from '../utils/helpers';

const ProductGroupItem = ({ data, location }) => {
	const { queryParameters } = useQueryParameters();
	const { language, t } = useTranslation('template_product_group');

	const group_id = data.group.group_id;
	const group = getVariantByLanguage(language, data.group.group_variants);
	if (!group) return <></>;

	return (
		<Framework
			description={group.seo_description}
			location={location}
			tags={group.seo_keywords}
			title={group.seo_title}
			tracking={{ content_group: 'ProductGroup' }}
		>
			<div className="grid-list container px-0" id="content">
				<div className="grid-list-header">
					<div className=" px-0 mt-lg-3 mt-2">
						<nav aria-label="breadcrumb">
							<Breadcrumb
								className="horizontal-list"
								links={[{ active: true, title: group.title }]}
								test={true}
							/>
						</nav>
					</div>

					<div className="container px-lg-0 mb-3">
						<PageHeader
							excerpt={<Trans defaults={group.excerpt} t={t} />}
							pageVariant="nested_page"
							title={group.title}
						/>
					</div>
				</div>
				<div className="grid-list-groups mt-lg-4 mt-2">
					<TestFilters group_id={group_id} />
				</div>
				<div className="grid-list-products my-lg-2">
					<div className="mb-3 container">
						<ProductToggleListType />
					</div>
					<div className="">
						<ProductList
							grouping
							has_markers={true}
							include_discount={queryParameters?.discount}
							include_groups={[group_id]}
							include_product_settings={
								queryParameters?.product_settings
									? [].concat(queryParameters?.product_settings)
									: null
							}
							include_product_types={
								queryParameters?.product_type?.length
									? queryParameters?.product_type
									: null
							}
							tracking={{
								item_list_name: 'Products on product group item page',
								source: 'group',
							}}
							variant={queryParameters?.list_type || 'list'}
						/>
					</div>
				</div>
			</div>
		</Framework>
	);
};

ProductGroupItem.propTypes = {
	data: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired,
};

export default ProductGroupItem;

export const pageQuery = graphql`
	query ProductGroupById($id: String!) {
		group(id: { eq: $id }) {
			id
			group_id
			group_variants {
				excerpt
				language {
					code
				}
				seo_description
				seo_keywords
				seo_title
				slug
				title
			}
		}

		locales: allLocale {
			...translationFields
		}
	}
`;
